<template>
  <div>
    <p>{{ this.address }}</p>
    <p>{{ this.region }}</p>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "event-address",
  props: ["street", "streetTwo", "city", "state", "zip", "country"],
  computed: {
    address: function() {
      console.log(this.streetTwo)
      if (this.street && this.streetTwo) return `${this.street} ${this.streetTwo}`;
      if (this.street && !this.streetTwo) return `${this.street}`;
      if (!this.street && this.streetTwo) return `${this.streetTwo}`;
    },
    region: function() {
      if (this.city && (this.state || this.zip || this.country))
        return `${this.city}, ${this.state} ${this.zip} ${this.country}`;
      if (this.city && !(this.state || this.zip || this.country))
        return `${this.city}`;
      if (!this.city && (this.state || this.zip || this.country))
        return `${this.state} ${this.zip} ${this.country}`;
    }
  }
});
</script>

<style scoped>
p {
  margin-bottom: 0;
}
</style>
